module.exports = __webpack_public_path__ + "files/ecf7159d16b224a343f6bdf1c978aec0.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/ubuntu-italic-webfont.woff2
 ** module id = 1035
 ** module chunks = 0
 **/